import FullMarket from "../../images/analysis/FullMarket.svg"
import FullMarketColored from "../../images/analysis/Active-FullMarket.svg"
import ReportLib from "../../images/analysis/ReportLib.svg"
import ReportLibColored from "../../images/analysis/Active-ReportLib.svg"
import Market from "../../images/analysis/Market.svg"
import MarketColored from "../../images/analysis/Active-Market.svg"
import FreeForm from "../../images/analysis/Freeform.svg"
import FreeFormColored from "../../images/analysis/Active-Freeform.svg"
import HCP from "../../images/analysis/HCP.svg";
import HCPColored from "../../images/analysis/Active-HCP.svg";
import { getMarketPackageCode, getModuleCode } from "../oneintelligence/OneIntelligenceHelper";

export const getAnalysisSubTitle = () => {
    const moduleCode = getModuleCode();
    const marketPackageCode = getMarketPackageCode();
    if (moduleCode === "whitespacesmodule") {
        return "Select whitespace candidates from categories or industries that are relevant to your in-market brands and products.";
    }
    if (["tiktokaudiences", "gdn"].includes(moduleCode)) {
        return "Select the audience targeting option you want to apply.";
    }
    if (moduleCode === "expertmedia") return "Please choose the specific media you would like to analyze.";
    if (marketPackageCode === "whitespaces") return "";
    return "Select the type of analysis you'd like to perform.";
};
export const getAnalysisTitle = () => {
    return "Exploration Zones"
}
export const getAnalysisImage = (code, disabled) => {
    switch (code) {
        case "la_demographicsattributes":
        case "analysis_gdn&trv_affinity":
        case "tiktokhastags":
        case "fullmarket": {
            if (disabled) return FullMarket;
            return FullMarketColored;
        }
        case "analysis_gdn&trv_purchase":
        case "tiktokinterest":
        case "la_behavioralattributes":
        case "icd10clinicalmodification":
        case "singlecategory": {
            if (disabled) return ReportLib;
            return ReportLibColored;
        }
        case "analysis_gdn&trv_topic":
        case "tiktokvideointeractions":
        case "purchaseintentions":
        case "la_purchaseintent":
        case "icd10procedurecodingsystem":
        case "petientmarketscan":
        case "hcpmarketscan":
        case "marketcategory": {
            if (disabled) return Market;
            return MarketColored;
        }
        case "la_hobbiesinterests":
        case "hcpattributes": {
            if (disabled) return HCP;
            return HCPColored;
        }
        default: {
            if (disabled) return FreeForm;
            return FreeFormColored;
        }
    }
};
export const getAnalysisName = (type, code) => {
    const { titleObj = {}, title, key } = type;
    if (key === "analysis_politicaltaxonomy") return "Government Taxonomy"
    return titleObj[code] || title
}
export const getAnalysisDescription = (type, code) => {
    const { description, descriptionObj = {} } = type;
    return descriptionObj[code] || description
}